// 价格标签
const systemCode = {
    1: '协议价',
    2: '送货价',
    3: '牌面价',
}

export default systemCode;